/* @ngInject */
function trixEditorService ($timeout, $interval, $translate, UploadService, AttachmentService, NewAssetService, AssetPreviewService, EventListenerService, ToastService, BackendErrorParserService) {
  const service = {
    handleRichTextFieldFocus,
    handleRichTextFieldBlur,
    trixAutoLinker,
    setupTrixListeners
  }

  return service

  function handleRichTextFieldFocus (e, editor) {
    jQuery(editor.composition.delegate.toolbarController.element).addClass('show')
  }

  /**
   *
   * activeElement must be jQuery(document.activeElement)
   */
  function handleRichTextFieldBlur (e, editor, activeElement, CONSTANTS) {
    if (activeElement.hasClass('trix-input')) {
      return
    }
    jQuery(editor.composition.delegate.toolbarController.element).removeClass('show')
  }

  /**
   * Flags are the flags from your controller where you will be receiving data
   * This functions set's up all the necessary trix listeners for it upload and remove attachments functionally.
   * @param {Object} flags
   */
  function setupTrixListeners (flags, callbacks) {
    let loadingFiles = []

    EventListenerService.registerEventListener('trix-attachment-add', document, 'trix-attachment-add',
      { substitute: true }, event => {
        if (event.attachment.file) {
          _uploadAttachment(event.attachment, callbacks, flags, loadingFiles)
        }
      })

    EventListenerService.registerEventListener('trix-attachment-remove', document, 'trix-attachment-remove',
      { substitute: true }, event => {
        if (event.attachment.file) {
          const uuid = event.attachment.attachment.attributes.values.uuid
          const indexToRemoveLoadingFile = loadingFiles.findIndex(fileUUID => fileUUID === uuid)

          loadingFiles = loadingFiles.splice(indexToRemoveLoadingFile, 1)
        }
      })

    EventListenerService.registerEventListener('trix-initialize', document, 'trix-initialize',
      { substitute: true }, event => {
        if (!document.querySelector('.trix-button--icon-attach-files')) {
          _addAttachmentButtonToToolbar()
        }
      })
  }

  /**
   * Adds attachment button to trix toolbar, creates the button here and adds click listener
   */
  function _addAttachmentButtonToToolbar () {
    const trixEditor = jQuery('trix-editor')
    if (trixEditor.hasClass('post-trix-editor')) {
      const trixBlockButtons = document.querySelector('.trix-button-group--block-tools')
      const buttonHTML = `
      <button
        type="button"
        class="trix-button trix-button--icon trix-button--icon-attach-files"
        data-trix-action="x-attach" title="Attach Files"
        tabindex="-1"
      >Attach Files</button>
    `
      trixBlockButtons.innerHTML += buttonHTML
      document.querySelector('.trix-button--icon-attach-files')
        .addEventListener('click', _trixAddAttachment)
    }
  }

  function _trixAddAttachment () {
    const fileInput = document.createElement('input')

    fileInput.setAttribute('type', 'file')
    fileInput.setAttribute('accept', '.jpg, .png, .gif')

    fileInput.addEventListener('change', () => {
      _insertAttachment(fileInput.files[0])
    })

    fileInput.click()
  }

  function _insertAttachment (file) {
    const trixEditor = document.querySelector('trix-editor').editor
    trixEditor.insertFile(file)
  }

  function _uploadAttachment (attachment, callbacks, flags, loadingFiles) {
    const uuid = AttachmentService.generateUUID()
    flags.bLoading = true
    loadingFiles.push(uuid)

    return UploadService.uploadToS3(attachment.file)
      .then(successCallback)
      .catch(errorCallback)

    function successCallback (createdAsset) {
      const loadingFileIndex = loadingFiles.find(file => file === uuid)
      loadingFiles.splice(loadingFileIndex, 1)

      const mayTakeOutLoader = loadingFiles => loadingFiles.length === 0
      callbacks.addToAttachments({ id: createdAsset.id, isEmbedded: true })

      const getAttributes = (params = {}) => {
        const { attachments } = params
        const attachmentUrl =
          attachments?.removeDateCache
            ? AssetPreviewService.getAssetPreview(createdAsset.id, null, { noJwt: true, quality: 'ORIGINAL' })
            : AssetPreviewService.getAssetPreview(createdAsset.id, null, { noJwt: true, quality: 'ORIGINAL', forceRefresh: true })

        return {
          url: attachmentUrl,
          href: attachmentUrl,
          uuid: createdAsset.id
        }
      }

      attachment.setAttributes(getAttributes())
      $timeout(() => {
        flags.bLoading = !mayTakeOutLoader(loadingFiles)
      }, 2000)

      const interval = $interval(() => {
        NewAssetService.checkAssetHasThumb(createdAsset.id, 'HIGH').then((assetHasThumb) => {
          if (!assetHasThumb) {
            return
          }

          $interval.cancel(interval)
          attachment.setAttributes(getAttributes({ attachments: { removeDateCache: true } }))
        })
      }, 8000)
    }

    function errorCallback (error) {
      const loadingFileIndex = loadingFiles.findIndex(file => file === uuid)
      loadingFiles.splice(loadingFileIndex, 1)

      flags.bLoading = false
      if (BackendErrorParserService.isInvalidFileError(error)) {
        ToastService.showErrorToast($translate.instant('fileExtensionNotAllowed'))
      }
    }
  }

  /**
   * Method to auto link url declared at editor content
   * Can you specify the editor element, this method will automatically create the link based on text
   * e.g.: `https://app.deskfy.io/` text will be `<a target="_blank" href="https://app.deskfy.io/">https://app.deskfy.io/</a>`
   * This only works with trix editor, when it is outside cannot be format the text, if necessary it will have to be formatted manually
   *
   * Note: This only works when the editor has been changed, i.e., when is inside the editor
   *
   * @param {HTMLElement} editorEl
   *
   * Note: This function is from the TrixEditor team and it was make with CoffeeScript and transpile to JavaScript
   *
   * More info: https://github.com/basecamp/trix/issues/167
   */
  function trixAutoLinker (editorEl) {
    const bind = function (fn, me) { return function () { return fn.apply(me, arguments) } }

    const INPUT = document.createElement('input')
    INPUT.type = 'url'
    INPUT.required = true

    const PATTERN = /(https?:\/\/\S+\.\S+)\s/ig

    const isValidURL = value => {
      INPUT.value = value
      return INPUT.checkValidity()
    }

    function TrixAutoLinker (element) {
      this.element = element
      this.autoLink = bind(this.autoLink, this)
      this.editor = this.element.editor
      this.element.addEventListener('trix-change', this.autoLink)
      this.autoLink()
    }

    TrixAutoLinker.prototype.autoLink = function () {
      const ref = this.getURLsWithRanges()
      const len = ref.length
      const results1 = []

      for (let i = 0; i < len; i++) {
        const ref1 = ref[i]
        const url = ref1.url
        const range = ref1.range

        if (this.getHrefAtRange(range) !== url) {
          const currentRange = this.editor.getSelectedRange()
          this.editor.setSelectedRange(range)
          if (this.editor.canActivateAttribute('href')) {
            this.editor.activateAttribute('href', url)
          }
          results1.push(this.editor.setSelectedRange(currentRange))
        } else {
          results1.push(0)
        }
      }
      return results1
    }

    TrixAutoLinker.prototype.getDocument = function () {
      return this.editor.getDocument()
    }

    TrixAutoLinker.prototype.getDocumentString = function () {
      return this.getDocument().toString()
    }

    TrixAutoLinker.prototype.getHrefAtRange = function (range) {
      return this.getDocument().getCommonAttributesAtRange(range).href
    }

    TrixAutoLinker.prototype.getURLsWithRanges = function () {
      const results = []
      const string = this.getDocumentString()
      let match = null

      while ((match = PATTERN.exec(string)) !== null) {
        const url = match[1]
        if (isValidURL(url)) {
          const position = match.index
          const range = [position, position + url.length]
          results.push({
            url: url,
            range: range
          })
        }
      }
      return results
    }

    return new TrixAutoLinker(editorEl)
  }
}

export { trixEditorService }
